import { useEffect } from "react";
import axios from "axios";

// Pings the server once a minute while the user is actually interacting, so
// Admin → Users "Active Time" counts real use and skips idle/background tabs.
export function useActivityHeartbeat({ url, enabled }) {
  useEffect(() => {
    if (!enabled) return undefined;
    let last = Date.now();
    const bump = () => { last = Date.now(); };
    const events = ["mousemove", "keydown", "scroll", "touchstart", "wheel", "click"];
    events.forEach((e) => document.addEventListener(e, bump, { passive: true }));
    const t = setInterval(() => {
      if (document.visibilityState === "visible" && Date.now() - last < 60_000) {
        axios.post(url).catch(() => {});
      }
    }, 60_000);
    return () => {
      clearInterval(t);
      events.forEach((e) => document.removeEventListener(e, bump));
    };
  }, [url, enabled]);
}
